import React from 'react';

function Header(props) {

    return (
        <ul className="mypage_inner">
            <li>주문/배송내역</li>
            <li>취소/반품/교환신청</li>
            <li>실시간 채팅문의</li>
            <li>쿠폰 조회</li>
        </ul>
    );
}

export default Header;
